import ReducerBuilder from 'classes/ReducerBuilder';
import initialState from './initialState';

export default ReducerBuilder.make(initialState)
    .forType('RECEIVED_ALL_RESOURCES_SITE')
    .reduce((state, action) => {
      state.resources = action.resources.reduce((resources, site) => {
        resources[site.id] = site;
        return resources;
      }, {});
    })
    .build();



// WEBPACK FOOTER //
// ./public/sites/reducer.js